
import {Link, useLocation, useNavigate} from 'react-router-dom';
import Styles from './Login.module.css';
import { useState } from 'react';
import {login} from '../api/login';


const Login = ()=>{
    //拿到location
    const location = useLocation();
    //如果有from就拿到pathname，没有就给默认值/
    const from = location.state?.from?.pathname || "/admin";
    const navigate = useNavigate();

    //状态管理username和password，以便React知道这两个值的随时变化。
    const [form,setForm] = useState({
        username:'',
        password:''
    });

    //用于显示错误信息
    const [error,setError] = useState('');

    const handleChange = (event)=>{
        const {name,value} = event.target; //从输入框获取名字和内容
        setForm ({
            ...form,    // 保留原有内容 [对象展开运算符 ...]
            [name]:value // 更新当前修改的字段（username 或 password）[动态属性名]
        });
    };

    //处理表单提交
    const handleSubmit = async (event)=>{
        event.preventDefault();//阻止表单默认提交行为（避免刷新页面）

        try {
            
            const response = await login(form);
            //处理请求结果
            if(response.data.code===200){
                const token = response.data.data;
                localStorage.setItem('token',token);// 把token存在本地(localStorage)
                alert('登陆成功');
                console.log(location);
                //跳转页面,replace为true代表消除了此页面/login的历史记录。
                navigate(from,{replace:true});
            }else{
                setError(response.data.message || '登陆失败，请检查用户名和密码');
            }
        } catch (error) {
            setError('网络请求失败，服务器可能未启动');
        }
    }

    
    return (
        <div className={Styles.common}>
            <form onSubmit={handleSubmit} className={Styles.common}>
                    <input
                        value={form.username}  // 输入值绑定到状态
                        onChange={handleChange} 
                        type="text" 
                        name="username" 
                        placeholder="USERNAME" 
                        required="required" 
                        className={Styles.inputWithUsrnameIcon}
                    />
                    <input
                        value={form.password}
                        onChange={handleChange} 
                        type="password" 
                        name="password" 
                        placeholder="PASSWORD" 
                        required="required" 
                        className={Styles.inputWithPasswordIcon}
                    />
                    <button
                        type='submit'
                        className={Styles.button} 
                    >
                        LOGIN
                    </button>
                        {error&&<p style={{color:'red'}}>{error}</p>}
            </form>
            <Link to='/login/forgetPassword' className={Styles.link}>
                Forget password?
            </Link>
        </div>
    )
}

export default Login;